import React from 'react';

interface PillTab {
  id: string;
  label: string;
}

interface SubTabPillsProps {
  tabs: PillTab[];
  active: string;
  onChange: (id: string) => void;
  errorTabs?: string[];
  disabledTabs?: string[];
}

const SubTabPills: React.FC<SubTabPillsProps> = ({
  tabs,
  active,
  onChange,
  errorTabs = [],
  disabledTabs = []
}) => {
  return (
    <div className="sub-tab-pills">
      {tabs.map((t) => {
        const hasError = errorTabs.includes(t.id);
        const isDisabled = disabledTabs.includes(t.id) && !hasError;

        return (
          <button
            key={t.id}
            type="button"
            className={`sub-tab-pill ${active === t.id ? 'active' : ''} ${
              hasError ? 'has-error' : ''
            } ${isDisabled ? 'disabled' : ''}`}
            disabled={isDisabled}
            title={
              isDisabled
                ? 'Complete Production Data before entering A3 manufacturing data.'
                : undefined
            }
            onClick={() => {
              if (!isDisabled) {
                onChange(t.id);
              }
            }}
          >
            <span>{t.label}</span>
            {hasError && <span className="sub-tab-error-dot" />}
          </button>
        );
      })}
    </div>
  );
};

export default SubTabPills;
